// @ts-nocheck
import React, { useState } from 'react'
import { PrensaEngine } from '@xprog/prensa'
import { Block } from '@xprog/prensa'
import * as t from '../types'
import * as S from './styled'
import map from 'lodash/map'

const InputBox = PrensaEngine.styled('input', {
  border: '1px solid #BFBFBF',
  borderRadius: '$default',
  cursor: 'pointer',
  height: '15px',
  mr: '6px',
  width: '15px'
})
export {
  InputBox
}

const SelectInput: React.FC<t.InputProps> = ({ content, setSelectedItems, selectedItems, clear }) => {
  const [checks, setChecks] = useState<Record<string, boolean>>({});

  const selectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;
    setChecks(prev => ({ ...prev, [value]: checked }));
  }

  React.useEffect(() => {
    const checkedItems = Object.entries(checks).filter(([key, value]) => value)
    if(selectedItems){
      setSelectedItems(checkedItems);
    }
  }, [checks]);
  
  React.useEffect(() => {
    if (clear) {
      setChecks({});
      setSelectedItems([])
    }
  }, [clear]);

  return (
    <Block 
      css={{ 
        align: ['column', 'left', 'top'],
        '@lg': {
          align: ['row', 'left', 'top'],
          flexWrap: 'wrap',
          width: '100%',
          maxWidth: '1000px'
        }
      }}>
      {map(content, (item, index) => {
        return (
          <Block 
            key={index}
            css={{ 
              align: ['row', 'left', 'center'], 
              width: '100%',
              '@lg': {
                width: '30%',
                mr: '$5'
              }}}>
            <InputBox 
              type='checkbox' 
              onChange={selectChange} 
              value={item.selectContent}
              checked={checks[item.selectContent] || false}
            />
            <S.Label
              customCss={{
                fontSize: '15px',
                fontWeight: 400,
                lineHeight: 'normal',
                mb: '$5',
                mt: '2px',
                width: '100%',
              }}>
              {item.selectContent}
            </S.Label>
          </Block>
        )
      })}
    </Block>
  )
}

export default SelectInput